// extracted by mini-css-extract-plugin
module.exports = {"rangeArrows":"RangeArrows_rangeArrows__2_5QN"};